// const colorsObj = {
//   "red": "#D32F2F",
//   "pink": "#C2185B",
//   "purple": "#7B1FA2",
//   "deepBlue": "#512DA8",
//   "indigo": "#303F9F",
//   "blue": "#1976D2",
//   "lightBlue": "#0288D1",
//   "cyan": "#0097A7",
//   "teal": "#00796B",
//   "green": "#388E3C",
//   "lightGreen": "#689F38",
//   "lime": "#AFB42B",
//   "yellow": "#FBC02D",
//   "amber": "#FFA000",
//   "orange": "#F57C00",
//   "deepOrange": "#E64A19",
//   "brown": "#5D4037",
//   "grey": "#616161",
//   "blueGray": "#455A64"
// };

const colorsArr = [
  "#D32F2F",
  "#C2185B",
  "#7B1FA2",
  "#512DA8",
  "#303F9F",
  "#1976D2",
  "#0288D1",
  "#0097A7",
  "#00796B",
  "#388E3C",
  "#689F38",
  "#AFB42B",
  "#FBC02D",
  "#FFA000",
  "#F57C00",
  "#E64A19",
  "#5D4037",
  "#616161",
  "#455A64"
];

/**
 * Randomly choose a color from array
 */
export function getRandomColor() {
  return colorsArr[Math.floor(Math.random() * colorsArr.length)];
}


// WEBPACK FOOTER //
// ./src/utils/colors.js